interface CountBadgeProps {
  count: number;
  max?: number;
  pulse?: boolean;
  className?: string;
}

/**
 * Numeric badge with optional max cap and pulse animation.
 * Renders nothing when count is 0.
 */
export function CountBadge({
  count,
  max = 99,
  pulse = false,
  className = "",
}: CountBadgeProps) {
  if (count <= 0) return null;

  const display = count > max ? `${max}+` : String(count);

  return (
    <span
      aria-label={`${count} items`}
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold leading-none ${pulse ? "animate-pulse" : ""} ${className}`}
    >
      {display}
    </span>
  );
}
